import { isDeviceNative } from './utils/deviceDetection';
import { bootstrapConfig, headerConfig } from './config';

export function getBootstrapConfig() {
  if (
    isDeviceNative() &&
    headerConfig.myAccount &&
    headerConfig.myAccount.neverOpenOnNative &&
    bootstrapConfig['@feature/myaccount']
  ) {
    bootstrapConfig['@feature/myaccount'].neverOpen = true;
  }

  return bootstrapConfig;
}
